import { render, staticRenderFns } from "./News.vue?vue&type=template&id=c81b1338&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./News.vue?vue&type=style&index=0&id=c81b1338&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81b1338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c81b1338')) {
      api.createRecord('c81b1338', component.options)
    } else {
      api.reload('c81b1338', component.options)
    }
    module.hot.accept("./News.vue?vue&type=template&id=c81b1338&scoped=true", function () {
      api.rerender('c81b1338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/News/News.vue"
export default component.exports